import{ExportApiClientEnum as o}from"../consts/export.js";const r=r=>"DCS"===r?o.ClimateSource:o.PowerSource;export{r as getExportApiClientEnumBySegment};
